import { render } from "./addNewCard.vue?vue&type=template&id=67fdd300&scoped=true"
import script from "./addNewCard.vue?vue&type=script&lang=js"
export * from "./addNewCard.vue?vue&type=script&lang=js"

import "./addNewCard.vue?vue&type=style&index=0&id=67fdd300&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fdd300"]])

export default __exports__